import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import React, { useEffect } from 'react';
import { FullPageSpinner } from '../components/dumb/spinners';
import { defaultRequest } from './msalInstance';

/**
 * Forces Authentication to occur via MSAL before rendering the child components
 *
 * LOCAL DEV: When azureAdLogin toggle is false (from backend HUB_SETTINGS),
 * authentication is bypassed to allow local development without Azure AD credentials.
 */
const ForceMsalAuthentication: React.FC = ({ children }) => {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  // Check if Azure AD login is disabled (for local development)
  const azureAdLoginEnabled = window.HUB_SETTINGS?.toggles?.azureAdLogin ?? true;

  useEffect(() => {
    //if (azureAdLoginEnabled && inProgress === 'none' && !isAuthenticated) { //uncomment when developing locally
    if (inProgress === 'none' && !isAuthenticated) {
      instance
        .acquireTokenRedirect(defaultRequest)
        .catch((e) => console.error(e));
    }
  //}, [azureAdLoginEnabled, instance, inProgress, isAuthenticated]); uncomment when developing locally
  }, [instance, inProgress, isAuthenticated]);

  // Bypass authentication if disabled, uncomment when developing locally
  // if (!azureAdLoginEnabled) {
  //   return <>{children}</>;
  // }

  return <>{isAuthenticated ? children : <FullPageSpinner />}</>;
};

export default ForceMsalAuthentication;
